export * from './alert.component';
export * from './alert';
export * from './alert.service';



// WEBPACK FOOTER //
// ./src/app/alert/index.ts